'use client'

import { Alert, AlertDescription } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { Bug, ExternalLink } from 'lucide-react'

export function StagingBanner() {
  const version = process.env.NEXT_PUBLIC_STAGING_VERSION
  const prUrl = process.env.NEXT_PUBLIC_STAGING_PR_URL

  if (!version || !prUrl) {
    return null
  }

  const handleThrowError = () => {
    throw new Error('Uncaught test error from StagingBanner')
  }

  return (
    <Alert
      variant="warning"
      className={cn(
        'rounded-none  border-x-0 border-t-0 bg-card !border-b-warning/20',
        'flex items-center justify-center gap-2',
        'py-2 text-center',
      )}
    >
      <AlertDescription className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-warning text-sm">
        <span className="font-semibold whitespace-nowrap">
          Staging <span className="max-md:sr-only">Environment</span>
        </span>
        <span className="hidden sm:inline">•</span>
        <span className="whitespace-nowrap">Version: {version}</span>
        <span className="hidden sm:inline">•</span>
        <a
          href={prUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1 underline hover:opacity-80 transition-opacity whitespace-nowrap"
        >
          <span className="sr-only">View</span> Release PR
          <ExternalLink className="h-3 w-3" />
        </a>
        <span className="hidden sm:inline">•</span>
        <Button
          variant="outline"
          size="sm"
          onClick={handleThrowError}
          className="h-6 px-2 text-xs border-warning/20 hover:bg-warning/10"
        >
          <Bug className="h-3 w-3 " />
          <span className="max-md:sr-only pl-1">Throw Error</span>
        </Button>
      </AlertDescription>
    </Alert>
  )
}
